import useAsync from "~/composables/use-async";
import AuthAPI from "~/services/auth";
import useUserStore from "~/stores/user";
import getErrorLocalePathMessage from "~/utils/locale";

export default function useSSOLogin(options?: { onSuccess?: () => void; onError?: (error: Error) => void }) {
  const router = useRouter();
  const toaster = useToast();
  const { t, te } = useI18n();
  const userStore = useUserStore();

  const onSocialLoginError = (error: Error) => {
    const err = error as Error & { code?: string; token: string; provider: TAuthProvider };

    if (options?.onError) {
      options.onError(error);
      return;
    }

    if (err.code === "device_limit_exceeded") {
      userStore.logout();
      router.push({ path: "/auth/login/", query: { deviceNoLongerAllowedError: "true" } });
    }
    const { message } = getErrorLocalePathMessage(err.message, { t, te });
    toaster.error(message);
  };
  const onSocialLoginSuccess = () => {
    if (options?.onSuccess)
      options.onSuccess();
  };

  const {
    run: executeSocialLogin,
    loading: socialLoginLoading,
  } = useAsync(AuthAPI.signinWithProvider, { onSuccess: onSocialLoginSuccess, onError: onSocialLoginError });

  return {
    executeSocialLogin,
    socialLoginLoading,
  };
}
